import { Box } from '@mui/material';
import { BarChart } from '@mui/x-charts';

// Converts the string "mm:ss" to seconds
const parseTimeToSeconds = (timeStr) => {
  if (!timeStr || !timeStr.includes(':')) return NaN;

  const [mm, ss] = timeStr.split(':').map(Number);
  if (isNaN(mm) || isNaN(ss)) return NaN;

  return mm * 60 + ss;
};

// Calculation of distribution by time ranges
const getTimeFillDistribution = (data) => {
  if (!Array.isArray(data) || data.length === 0) {
    return { labels: [], percents: [] };
  }

  const secondsArray = data
    .map((d) => parseTimeToSeconds(d.time_to_fill))
    .filter((sec) => !isNaN(sec));

  const total = secondsArray.length;
  if (total === 0) return { labels: [], percents: [] };

  const maxMinutes = Math.ceil(Math.max(...secondsArray) / 60) + 1;
  const binLimits = Array.from(
    { length: Math.ceil(maxMinutes / 2) },
    (_, i) => (i + 1) * 2
  );
  const binLabels = binLimits.map((min) => `${min} min`);
  const binCounts = new Array(binLimits.length).fill(0);

  secondsArray.forEach((sec) => {
    binLimits.forEach((limit, i) => {
      const lower = i === 0 ? 0 : binLimits[i - 1] * 60;
      const upper = limit * 60;
      if (sec > lower && sec <= upper) {
        binCounts[i]++;
        return;
      }
    });
  });

  const cumulativePercents = [];
  let cumulativeSum = 0;

  binCounts.forEach((count) => {
    const percent = +((count / total) * 100).toFixed(2);
    cumulativeSum = +(cumulativeSum + percent).toFixed(2);
    cumulativePercents.push(cumulativeSum);
  });

  return {
    labels: binLabels,
    percents: cumulativePercents,
  };
};

function CumulativeFillTimeChart({ data }) {
  const { labels, percents } = getTimeFillDistribution(data);

  return (
    <Box display="flex" justifyContent="center">
      <BarChart
        xAxis={[
          {
            id: 'time',
            data: labels,
            scaleType: 'band',
            label: 'Time to Fill (minutes)',
          },
        ]}
        yAxis={[
          {
            label: 'Percent',
            min: 0,
            max: 100,
          },
        ]}
        series={[
          {
            data: percents,
            label: 'Fill % per range',
            color: '#1976d2',
          },
        ]}
        width={800}
        height={400}
      />
    </Box>
  );
}

export default CumulativeFillTimeChart;
